'use client';

import classes from "./public_header.module.css";
import Link from "next/link";
import { usePathname } from "next/navigation";
import Bell from '@/assets/svg/icons/bell.svg';
import HelpCircle from '@/assets/svg/icons/help-circle.svg';
import Menu from '@/assets/svg/menu-2.svg';
import { forwardRef, useEffect, useState } from "react";
import NavAside from "./public_header_nav";
import PublicHeaderNavItems from "./public_header_nav_items";
import PublicHeaderButtons from "./public_header_buttons";
import { useContext } from "react";
import AuthContext from "@/providers/auth-context";
import ScreenContext from "@/providers/screen-context";
import CustomSVG from "../common/svg";
//import ProfileDropdown from "./public_header_profile_dropdown";
import CustomButton from "../common/buttons/button";
import Avatar from "../common/avatar/avatar";
import { Dropdown } from "react-bootstrap";
//import NotificationDropdown from "./notification_dropdown";
import { CheckScroll } from "@/functions/check_scroll";
import { ResponsiveBrandLogo } from '@/components/common/brand_logo/brand_logo';
import dynamic from "next/dynamic";
import { useSession } from "next-auth/react";

const ProfileDropdown = dynamic(() => import('./public_header_profile_dropdown'), { ssr: false });
const NotificationDropdown = dynamic(() => import('./notification_dropdown'), { ssr: false });
const HelpDropdown = dynamic(() => import('./help_dropdown'), { ssr: false });

const CustomToggle = forwardRef(function CustomToggle({ children, onClick }, ref) {
    return (
        <div ref={ref} className="d-flex align-items-center gap-1 pointer" onClick={(e) => {e.preventDefault(); onClick(e);}}>
                {children}
        </div>
    )
});

const white_headers = ["/szervezom", "/szolgaltatok", "/uikit_tests", "/profilom", "/bejelentkezes", "/regisztracio", "/elfelejtett-jelszo", "/uikit_tests", "/uj-email", "/uj-jelszo", "/uj-regisztracio", "/szolgaltato-bejelentkezes", "/szolgaltato/regisztracio", "/sitemaps", "/sitemap", "/sitemap/xml"];
const no_headers_before_login = ["/hirdetoi-fiok"];
const no_headers_after_login = ["/hirdetoi-fiok"];
const organizer_titles = {
    "": "Összefoglalás",
    programok: "Programok",
    teendoim: "Teendőim",
    szolgaltatok: "Szolgáltatók",
    vendeglista: "Vendéglista",
    koltsegvetes: "Költségvetés",
    uzenetek: "Üzenetek",
    "ultetesi-rend": "Ültetési rend",
    weboldal: "Weboldalam",
    "eskuvoi-segedlet": "Segédlet"
};

export default function PublicHeader() {
    const path = usePathname();
    const [showNav, setShowNav] = useState(false);
    const [showLoginNav, setShowLoginNav] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const userData = useContext(AuthContext);
    const { screenWidth, isCompactDevice, organizerHeaderDetail, openPlanner } = useContext(ScreenContext);
    const { data: clientSession, status } = useSession();
    const effectiveSession = status !== "loading" ? (clientSession ?? null) : null;
    const isMobileHeader = isCompactDevice || (screenWidth !== undefined ? screenWidth <= 480 : false);
    const isOrganizerWorkspace = /^\/szervezom\/[^/]+(?:\/|$)/.test(path);
    const organizerSection = isOrganizerWorkspace ? (path.split("/")[3] ?? "") : "";
    const organizerTitle = organizer_titles[organizerSection] ?? "Szervezőm";

    const no_headers = (effectiveSession ? no_headers_after_login : no_headers_before_login)

    const openSideBar = () => {
        if (isMobileHeader && isOrganizerWorkspace) {
            openPlanner();
            return;
        }
        setShowNav(!showNav);
    }

    const toggleLoginNav = () => {
        setShowLoginNav(!showLoginNav);
    }
    

    useEffect(() => {
        CheckScroll(setIsScrolled);
        const handleScroll = () => {
            CheckScroll(setIsScrolled);
        };

        window.addEventListener('scroll', handleScroll);
        return () => { window.removeEventListener('scroll', handleScroll); };
    }, []);

    if(path.startsWith("/weboldal")) return <></>

    let white_header = false;
    for(let w in white_headers) {
        if(path.startsWith(white_headers[w])) white_header = true;
    }

    let no_header = false;
    for(let n in no_headers) {
        if(path.startsWith(no_headers[n])) no_header = true;
    }

    return <header className={`${classes.header} ${no_header ? classes["no-header"] : ""} ${!white_header ? classes.main : classes["non-main"]} ${isScrolled ? classes["scrolled"] : ""}`}>
        {<CustomButton size="md" className={`${classes["planner-btn"]}`} hierarchy="tertiary-gray" icon="only" is_svg={true} svg={Menu} aria-label={isMobileHeader && isOrganizerWorkspace ? "Szervezői menü" : "Főmenü"} onClick={() => openSideBar()} ></CustomButton>}
        <div className={`d-flex w-auto h-100 position-relative ${classes["nav-container"]}`}>
            {isMobileHeader && isOrganizerWorkspace
                ? <div className={classes["workspace-heading"]}>
                    {organizerHeaderDetail?.text
                        ? <>
                            <h1 className={`${classes["workspace-title"]} color-gray-800 text-lg-semibold margin-0`} data-testid="organizer-workspace-title">
                                <button type="button" className={classes["workspace-title-button"]} onClick={organizerHeaderDetail.onClick}>{organizerHeaderDetail.text}</button>
                            </h1>
                            <span className={classes["workspace-subtitle"]} data-testid="organizer-workspace-subtitle">{organizerTitle}</span>
                        </>
                        : <h1 className={`${classes["workspace-title"]} color-gray-800 text-lg-semibold margin-0`} data-testid="organizer-workspace-title">{organizerTitle}</h1>}
                </div>
                : <>
                    <Link href="/" title="Esküvőhelyszín" className="d-flex align-items-center">
                        <ResponsiveBrandLogo />
                    </Link>
                    <div className={classes.navigations}>
                        <PublicHeaderNavItems />
                    </div>
                </>}
        </div>
        {<div className={`${classes.hamburger}`}>
            {<div className={classes.auth_buttons}>
                {status === "loading"
                    ? <div style={{width: 40, height: 40}} />
                    : (effectiveSession && effectiveSession.user && isMobileHeader)
                        ? <ProfileDropdown icon={userData.userData.photo} name={userData.userData.name} email={userData.userData.email} isProvider={userData.userData.isProvider} />
                        : <Dropdown show={showLoginNav} onToggle={toggleLoginNav}>
                            <Dropdown.Toggle as={CustomToggle} >
                                {/*<HamburgerMenu />*/}
                                <Avatar size="sm" url={""} />
                            </Dropdown.Toggle>
                            <Dropdown.Menu style={{width: 200}}>
                                <div className="d-flex flex-column align-self-stretch gap-2 padding-2">
                                    <PublicHeaderButtons noArrow onClick={toggleLoginNav} mobile />
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                }
            </div>}
        </div>}
        {<div className={classes.authentications}>
            {/*<div className={classes.search_icon}>
                <i className="bi bi-icon bi-icon-20 bi-search"/>
                <div className={classes.divider}></div>
            </div>*/}
            {<div className={classes.auth_buttons}>
                {status === "loading"
                    ? <div style={{width: 160, height: 40}} />
                    : (effectiveSession && effectiveSession.user && !isMobileHeader)
                        ? <div className="d-flex align-items-center gap-4">
                            {/*<CustomSVG className="stroke-gray-700" SvgFunction={Bell} height={20} width={20} />*/}
                            <NotificationDropdown show_badge>
                                <CustomSVG className="stroke-gray-700" SvgFunction={Bell} height={20} width={20} />
                            </NotificationDropdown>
                            <HelpDropdown>
                                <CustomSVG className="stroke-gray-700" SvgFunction={HelpCircle} height={20} width={20} />
                            </HelpDropdown>
                            <ProfileDropdown icon={userData.userData.photo} name={userData.userData.name} email={userData.userData.email}  isProvider={userData.userData.isProvider} />
                        </div>
                        : <PublicHeaderButtons />
                }
            </div>}
        </div>}
        <NavAside show={showNav} setShow={setShowNav} />
    </header>
}